import omniBrandsFollowing from './reducers';

import * as omniBrandsFollowingOperations from './operations';
import * as omniBrandsFollowingTypes from './types';
import * as omniBrandsFollowingAction from './actions';

export { omniBrandsFollowingOperations, omniBrandsFollowingTypes, omniBrandsFollowingAction };

export default omniBrandsFollowing;
